import { render } from "./ComplianceMatrixDetailsDialog.vue?vue&type=template&id=4502a9b5"
import script from "./ComplianceMatrixDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ComplianceMatrixDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__